import {
  fromJS
} from 'immutable';

import {
  CAMPAIGN_DATA_OF_USER, SALES_USERS_DATA, STATE_LIST, CLUSTER_LIST
} from '../action/salesUser_action_types';

const INITIAL_STTATE = fromJS({
  campaignsDataOfUser: [],
  salesUsersData: []
})

export default function (state = INITIAL_STTATE, action) {
  console.log(action);
  switch (action.type) {
    case CAMPAIGN_DATA_OF_USER: {
      return state.set('campaignsDataOfUser', action.payload);
    }

    case SALES_USERS_DATA: {
      return state.set('salesUsersData', action.payload);
    }

    case STATE_LIST: {
      return state.set('stateList', action.payload);
    }

    case CLUSTER_LIST: {
      return state.set('clusterList', action.payload);
    }
  }
  return state;
};



// WEBPACK FOOTER //
// ./web/reducer/salesUser_reducer.js